import {PURGE} from 'redux-persist';
import {actions} from '../util/actions';
// import {currentUnixTime} from 'util/dateConvert';

//Brian Richey Jr. Engineer 10/18/22

//SUMMARY: intial state is populated by information from drupal upon login
//mock state is the hard coded

//RECOMMENDATIONS: implement more data fields for binding score

const MULTI_SUBSCRIPTION_ROLES = new Set([
  "subscription_accountant",
  "subscription_admin",
  "subscription_implementor",
  "subscription_salesperson",
]);

const INITIAL_STATE = {
  user: {
    user_id: null,
    session_id: null,
    email: null,
    title: null,
    first_name: null,
    last_name: null,
    address: null,
    address2: null,
    city: null,
    state: null,
    zip: null,
    phone: null,
    ext: null,
    fax: null, 
    newsletter_sign_up: null,
    is_phone_verified: null,
    security_questions: [],
    sec_questions_set: null,
    app_tour: 0,
    app_tour_step: 0, 
    sonur_score: null,
    preference : {mode: 'auto', zoom: '100'},
    age_verified: null,
    customer_id: null,
    invoice_id : null,
    customer_code: null,
    customer_accounts: {},
    self_implemented: 0
  },
  is_sso: 0,
  isafeDirectSso: {
    processing: false,
    error: "",
  },
  teacher_subscriptions: {},
  subscription_schools: {},
  subscription_school_limits: {
    allowed: null,
    total: null,
    invoiceId: null,
  },
  school_levels: null,
  subscription_details: {},
  selected_subscriptions: {},
  become: 0,
  become_user: 0,
  become_origin: null,
  self_implemented: 0,
  self_implementation_notice: null,
  admin_roles: [],
  loginResponse : null,
  signedIn: false,
  font: 'default',
  token: null,
  anonToken: null,
  refreshToken: null,
  subscription_videos: [],
  announcements: [],
  curriculum_downloads: [],
  resources_loaded: false,
  teacher_implementations: [],
  teacher_implementations_fetched_at: null,
  teacher_implementations_loading: false,
  timerEndTime: 0,
  theme: null,
  session_validated_at: null,
  show_accounts_listing: false,
};

const nullify = item => {
  return item === undefined ? null : item;
};

const normalizeSelectionValue = (value) => String(value ?? "").trim();

const getSelectionIdentityKey = (selection = {}) => {
  const invoiceNumber = normalizeSelectionValue(selection?.invoice_number);
  const customerCode = normalizeSelectionValue(selection?.customer_code);
  const customerId = normalizeSelectionValue(selection?.customer_id);
  const invoiceId = normalizeSelectionValue(selection?.invoice_id);

  if (invoiceNumber && customerCode) {
    return `invoice_number:${invoiceNumber}|customer_code:${customerCode}`;
  }
  if (invoiceNumber && customerId) {
    return `invoice_number:${invoiceNumber}|customer_id:${customerId}`;
  }
  if (invoiceId && customerCode) {
    return `invoice_id:${invoiceId}|customer_code:${customerCode}`;
  }
  if (invoiceId && customerId) {
    return `invoice_id:${invoiceId}|customer_id:${customerId}`;
  }
  if (invoiceId) {
    return `invoice_id:${invoiceId}`;
  }
  return "";
};

const toIntegerOrNull = (value) => {
  if (value === undefined || value === null || value === "") {
    return null;
  }
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

const normalizeRoles = (roles) => {
  if (Array.isArray(roles)) {
    return roles
      .map((role) => {
        if (!role) return null;
        if (typeof role === "string") return { id: role };
        if (typeof role === "object") return role;
        return null;
      })
      .filter(Boolean);
  }
  if (roles && typeof roles === "object") {
    return Object.entries(roles).map(([id, name]) => ({ id, name }));
  }
  return [];
};

const normalizeProfileUser = (userProfile) => {
  if (!userProfile) return {};
  const candidate = userProfile?.user ?? userProfile;
  if (Array.isArray(candidate)) {
    const first =
      candidate.find((entry) => entry && typeof entry === "object") ??
      candidate[0];
    return first && typeof first === "object" ? first : {};
  }
  if (candidate && typeof candidate === "object") {
    return candidate;
  }
  return {};
};

const normalizeNewsletterSignup = (user = {}) => {
  if (!user || typeof user !== "object") return null;
  if (user.newsletter_signup !== undefined) return user.newsletter_signup;
  if (user.newsletter_sign_up !== undefined) return user.newsletter_sign_up;
  if (user.news_letter !== undefined) return user.news_letter;
  if (user.newsletter !== undefined) return user.newsletter;
  return null;
};

const normalizeCustomerAccounts = (rawCustomer) => {
  if (!rawCustomer || typeof rawCustomer !== "object" || Array.isArray(rawCustomer)) {
    return {};
  }
  if (
    Object.prototype.hasOwnProperty.call(rawCustomer, "customer_id") ||
    Object.prototype.hasOwnProperty.call(rawCustomer, "invoice_id") ||
    Object.prototype.hasOwnProperty.call(rawCustomer, "customer_code")
  ) {
    return {};
  }
  return rawCustomer;
};

const pickPrimaryCustomer = (rawCustomer, customerAccounts) => {
  if (rawCustomer === undefined || rawCustomer === null || rawCustomer === "") {
    return {};
  }
  if (typeof rawCustomer === "string" || typeof rawCustomer === "number") {
    return { customer_id: rawCustomer };
  }
  if (Array.isArray(rawCustomer)) {
    const first = rawCustomer.find((entry) => entry !== undefined && entry !== null);
    if (first && typeof first === "object") return first;
    if (typeof first === "string" || typeof first === "number") {
      return { customer_id: first };
    }
    return {};
  }
  if (typeof rawCustomer === "object") {
    if (
      Object.prototype.hasOwnProperty.call(rawCustomer, "customer_id") ||
      Object.prototype.hasOwnProperty.call(rawCustomer, "invoice_id") ||
      Object.prototype.hasOwnProperty.call(rawCustomer, "customer_code")
    ) {
      return rawCustomer;
    }
    const candidates = Object.values(customerAccounts || rawCustomer);
    const first = candidates.find((entry) => entry !== undefined && entry !== null);
    if (first && typeof first === "object") return first;
    if (typeof first === "string" || typeof first === "number") {
      return { customer_id: first };
    }
  }
  return {};
};

/*
const MOCK_STATE = {
  user: {
    uid: '1',
    name: 'qidian',
    mail: 'diqi@isafeventures.com',
    theme: '',
    signature: '',
    signature_format: null,
    created: '1603740710',//unix timestamps
    access: '1607102545',
    login: 1607103436,
    status: '1',
    timezone: 'America/Los_Angeles',
    language: '',
    picture: null,
    init: 'diqi@isafeventures.com',
    data: false,
    roles: {2: 'authenticated user', 3: 'administrator'},
    rdf_mapping: {
      rdftype: ['sioc:UserAccount'],
      name: {predicates: ['foaf:name']},
      homepage: {predicates: ['foaf:page'], type: 'rel'},
    },
  },
  token: 'MUABxWQgm90VD5jHqA3FGh-9jxqoAZSbIFXagYraMG0',
  cookie:
    'SESS75f4857b53f26f3e1c4dbfe5fb960454=qm5Cwz5wJae8z2mFsyGJljbiWTdMXT80uesg-L9mBgA; expires=Sun, 27-Dec-2020 21:10:37 GMT; Max-Age=2000000; path=/; HttpOnly',
  expires: '2020-12-27T21:10:37.000Z',
  schools: [],
  districts: [],
};
*/

export const authReducer = (
  state = INITIAL_STATE,
  // state = MOCK_STATE,
  action,
) => {
  switch (action.type) {
    case PURGE: {
      return INITIAL_STATE;
    }


    case actions.UPDATE_ACCESS_TOKEN: {
      const {response} = action
      return {
        ...state,
        token: response.access_token,
        loginResponse: response,
        session_validated_at: Date.now(),
      };
    }

    case actions.TOUCH_SESSION: {
      return {
        ...state,
        session_validated_at: Date.now(),
      };
    }

    case actions.USER_LOGIN: {
      const {loginResponse} = action;
      return {
        ...state,
        signedIn: true,
        loginResponse: loginResponse,
        session_validated_at: Date.now(),
      }
    }

    case actions.LOGOUT: {
      return INITIAL_STATE;
    }
    case actions.STORE_ANONYMOUS_TOKEN: {
      const {anonToken} = action;
      return {
        ...state,
        anonToken: anonToken,
      };
    }

case actions.STORE_PROFILE_INFO: {
  const { userProfile } = action;
  const user = normalizeProfileUser(userProfile);

  const rawCust = user.customer_id ?? null;
  const customerAccounts = normalizeCustomerAccounts(rawCust);
  const primaryCustomer = pickPrimaryCustomer(rawCust, customerAccounts);
  const {
    customer_id,
    invoice_id,
    customer_code
  } = primaryCustomer;
  const roles = normalizeRoles(user.roles);
  const newsletterSignup = normalizeNewsletterSignup(user);
  const hasMultipleCustomers = Object.keys(customerAccounts).length > 1;
  const showAccountsListing =
    hasMultipleCustomers &&
    roles.some((role) => MULTI_SUBSCRIPTION_ROLES.has(role.id));
  const pickValue = (value, fallback) =>
    value === undefined ? fallback : value;

  return {
    ...state,
    user: {
      ...state.user,
      user_id: pickValue(user.user_id, state.user.user_id ?? null),
      roles,
      email: pickValue(user.email, state.user.email ?? null),
      title: pickValue(user.title, state.user.title ?? null),
      first_name: pickValue(user.first_name, state.user.first_name ?? null),
      last_name: pickValue(user.last_name, state.user.last_name ?? null),
      address: pickValue(user.address, state.user.address ?? null),
      address2: pickValue(user.address2, state.user.address2 ?? null),
      city: pickValue(user.city, state.user.city ?? null),
      state: pickValue(user.state, state.user.state ?? null),
      zip: pickValue(user.zip, state.user.zip ?? null),
      phone: pickValue(user.phone, state.user.phone ?? null),
      ext: pickValue(user.ext, state.user.ext ?? null),
      fax: pickValue(user.fax, state.user.fax ?? null),
      newsletter_sign_up: newsletterSignup,
      newsletter_signup: newsletterSignup,
      is_phone_verified: pickValue(
        user.is_phone_verified,
        state.user.is_phone_verified ?? null
      ),
      security_questions: pickValue(
        user.security_questions,
        state.user.security_questions ?? []
      ),
      sec_questions_set: pickValue(
        user.sec_questions_set,
        state.user.sec_questions_set ?? null
      ),
      app_tour: pickValue(user.app_tour, state.user.app_tour ?? 0),
      app_tour_step: pickValue(
        user.app_tour_step,
        state.user.app_tour_step ?? 0
      ),
      sonur_score: pickValue(user.sonur_score, state.user.sonur_score ?? null),
      preference: pickValue(user.preference, state.user.preference),
      age_verified: pickValue(user.age_verified, state.user.age_verified ?? null),
      customer_id: customer_id ?? state.user.customer_id ?? null,
      invoice_id: invoice_id ?? state.user.invoice_id ?? null,
      customer_code: customer_code ?? state.user.customer_code ?? null,
      customer_accounts: customerAccounts,
      session_id: pickValue(user.session_id, state.user.session_id ?? null),
      self_implemented:
        user.self_implemented ?? state.user.self_implemented ?? 0,
    },
    show_accounts_listing: showAccountsListing,
    self_implemented:
      user.self_implemented ?? state.self_implemented ?? 0,
    session_validated_at: Date.now(),
  };
}


    case actions.SET_TEACHER_IMPLEMENTATIONS_FETCHED_AT: {
      const { fetchedAt } = action;
      return {
        ...state,
        teacher_implementations_fetched_at: fetchedAt ?? Date.now(),
      };
    }

    case actions.SET_TEACHER_IMPLEMENTATIONS_LOADING: {
      return {
        ...state,
        teacher_implementations_loading: Boolean(action.loading),
      };
    }

    case actions.STORE_TEACHER_SUBSCRIPTIONS: {
      const {getTeacherSubscriptions} = action;
      return {
        ...state,
        teacher_subscriptions: getTeacherSubscriptions.subscription
      }
    }

  case actions.STORE_TEACHER_IMPLEMENTATIONS: {
    const { implementations } = action;
    const fetchedAt = action.fetchedAt ?? Date.now();
    return {
      ...state,
      teacher_implementations: Array.isArray(implementations) ? implementations : [],
      teacher_implementations_fetched_at: fetchedAt,
      teacher_implementations_loading: false,
    };
  }

    case actions.STORE_SUBSCRIPTION_SCHOOLS: {
      const { schoolsByState } = action;
      return {
        ...state,
        subscription_schools: {
          ...state.subscription_schools,
          ...schoolsByState,
        },
      };
    }

    case actions.STORE_SUBSCRIPTION_SCHOOL_LIMITS: {
      const { limits = {} } = action;
      const currentLimits = state.subscription_school_limits || {
        allowed: null,
        total: null,
        invoiceId: null,
      };
      const allowed =
        Object.prototype.hasOwnProperty.call(limits, "allowed")
          ? toIntegerOrNull(limits.allowed)
          : currentLimits.allowed;
      const total =
        Object.prototype.hasOwnProperty.call(limits, "total")
          ? toIntegerOrNull(limits.total)
          : currentLimits.total;
      const invoiceId =
        Object.prototype.hasOwnProperty.call(limits, "invoiceId")
          ? limits.invoiceId === undefined || limits.invoiceId === null
            ? null
            : String(limits.invoiceId)
          : currentLimits.invoiceId ?? null;
      return {
        ...state,
        subscription_school_limits: {
          allowed,
          total,
          invoiceId,
        },
      };
    }

    case actions.STORE_SCHOOL_LEVELS: {
      const { schoolLevels } = action;
      return {
        ...state,
        school_levels: Array.isArray(schoolLevels) ? schoolLevels : [],
      };
    }

    case actions.STORE_RESOURCE_DOWNLOAD: {
      const { getSubscriptionVideos, getAnnouncements, getCurriculum } = action;
      return {
        ...state,
        subscription_videos: getSubscriptionVideos.videos,
        announcements: getAnnouncements.announcements,
        curriculum_downloads: getCurriculum.curriculum,
        resources_loaded: true,
      };
    }
    case actions.UPDATE_PROFILE_INFO: {
      const {userProfile} = action;
      console.log(userProfile);
      const newsletterSignup = normalizeNewsletterSignup(userProfile);
      return {
        ...state,
        user : {
          ...state.user,
          title: userProfile.title ?? state.user.title,
          first_name: userProfile.first_name,
          last_name: userProfile.last_name,
          address : userProfile.address,
          address2 : userProfile.address2,
          city : userProfile.city,
          state: userProfile.state,
          zip: userProfile.zip,
          phone: userProfile.phone,
          ext: userProfile.ext ?? state.user.ext,
          fax: userProfile.fax ?? state.user.fax,
          email: userProfile.email ?? state.user.email,
          newsletter_sign_up: newsletterSignup,
          newsletter_signup: newsletterSignup,
        }
      }
    }

    case actions.UPDATE_PROFILE_EMAIL_INFO: {
      const {email} = action;
      return {
        ...state,
        user : {
          ...state.user,
          email: email,
        }
      }
    }
    case actions.STORE_ADMIN_ROLES: {
      const {roles} = action;
      return {
        ...state,
        admin_roles:roles,
      }
    }

    case actions.SET_AGE_VERIFICATION: {
      return {
        ...state,
        user: {
          ...state.user,
          age_verified: 1,
        },
      };
    }

    case actions.PUT_SUBSCRIPTION_DETAIL: {
      const {subscription_details} = action;
      return {
        ...state,
        subscription_details:subscription_details,
      };
    }

    case actions.STORE_SELECTED_SUBSCRIPTION: {
      const selected_subscription = action?.selected_subscription || {};
      const currentSelection = state.selected_subscriptions || {};
      const nextSelectionKey = getSelectionIdentityKey(selected_subscription);
      const currentSelectionKey = getSelectionIdentityKey(currentSelection);

      if (!nextSelectionKey && !currentSelectionKey) {
        return state;
      }

      if (
        nextSelectionKey &&
        currentSelectionKey &&
        nextSelectionKey === currentSelectionKey
      ) {
        return state;
      }

      return {
        ...state,
        selected_subscriptions: { ...selected_subscription },
      };
    }

    case actions.SET_BECOME: {
      const {become} = action;
      return {
        ...state,
        become: become,
      };
    }

    case actions.SET_BECOME_ORIGIN: {
      const {origin} = action;
      return {
        ...state,
        become_origin: origin,
      };
    }

    case actions.SET_SELF_IMPLEMENTED: {
      const { value } = action;
      return {
        ...state,
        self_implemented: value,
        user: {
          ...state.user,
          self_implemented: value,
        },
      };
    }

    case actions.SELF_IMPLEMENTATION_SUCCESS:
    case actions.SELF_IMPLEMENTATION_FAILURE: {
      const { notice } = action;
      return {
        ...state,
        self_implementation_notice: notice,
      };
    }

      case actions.SET_BECOME_USER: {
      const {become_user} = action;
      return {
        ...state,
        become_user: become_user,
      };
    }


    case actions.SET_SSO_FLAG: {
      const {is_sso} = action;
      return {
        ...state,
        is_sso: is_sso,
      };
    }

    case actions.ISAFE_DIRECT_SSO_START: {
      return {
        ...state,
        isafeDirectSso: {
          processing: true,
          error: "",
        },
      };
    }

    case actions.ISAFE_DIRECT_SSO_SUCCESS: {
      return {
        ...state,
        isafeDirectSso: {
          processing: false,
          error: "",
        },
      };
    }

    case actions.ISAFE_DIRECT_SSO_FAILURE: {
      const { error } = action;
      return {
        ...state,
        isafeDirectSso: {
          processing: false,
          error: error || "Single Sign-On failed. Please try again.",
        },
      };
    }

    case actions.ISAFE_DIRECT_SSO_CLEAR: {
      return {
        ...state,
        isafeDirectSso: {
          processing: false,
          error: "",
        },
      };
    }

    default:
      return state;
  }
};
